<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-10 Verify panel
      v-spacer
      v-btn(icon @click="closeDialog" small color="primary")
        v-icon mdi-close
    v-divider

    v-card-text.primary--text.px-6.pt-6.pb-10
      div.d-flex.justify-center.mt-16(v-if="isFetching")
        v-progress-circular(:width="2" :size="50" color="primary" indeterminate)
      template(v-else)
        .text-md.font-semibold.mb-3 Check your patient's panel coverage.
        .text-sm.font-semibold.neutral500--text Panel
        v-text-field.text-sm.mt-2.round-xl(v-model="panel.name" background-color="neutral100" outlined dense height="48" readonly hide-details="auto")
        v-card.round-lg.neutral300.pa-4.mt-3(flat)
          //- Panel remark type
          template(v-if="isPanelRemarkType")
            .text-xs.font-semibold.mb-1 Panel remark
            .text-sm.font-normal {{ panelRemarkText }}
          //- Panel url type
          template(v-else)
            .text-xs.font-semibold Verify patient’s panel information
            v-text-field.text-sm.mt-2.round-xl(:value="panel.verification_link" :placeholder="$t('name')" background-color="neutral100" outlined dense height="48" readonly hide-details="auto")
              template(#append)
                y-button(label="Open link" size="xs" :disabled="!panel.verification_link" @click="openLink(panel.verification_link)")
          //- .text-xs.font-semibold.mt-3 Add note
        //- v-textarea.text-sm.mt-2.round-xl(v-model="selectedPayment.note" placeholder="Enter note" background-color="neutral100" outlined rows="3" hide-details="auto")

    v-divider
    v-card-actions.py-4.px-6
      //- v-btn.button-md.underline.px-0(@click="showDialog = false" text) {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(@click="closeDialog" color="primary" depressed) {{ $t('done') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'VerifyPanelDialog',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    selectedPanel: {
      default: null
    }
  },
  data: () => ({
    isFetching: false,
    panel: {},
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    payment: {
      get () {
        return this.selectedPayment 
      },
      set (newValue) {
        this.$emit('update:selectedPayment', newValue)
      }
    },
    isPanelRemarkType () {
      return this.panel?.display_remarks ?? false
    },
    panelRemarkText () {
      return this.panel?.remarks && this.panel.remarks !== '' ? this.panel.remarks : '-'
    }
  },
  mounted () {
    this.fetchPanelInfo()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchPanelInfo () {
      this.isFetching = true
      this.$axios.get(`/payment_methods/${this.selectedPanel}`)
        .then(resp => {
          this.panel = resp.data
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    openLink(link) {
      window.open(link, '_blank')
    },
    closeDialog () {
      this.$emit('closed')
      this.showDialog = false
    }
  }
}
</script>
